export default __webpack_public_path__ + "static/media/supper_apps_l2.28292878.png";